import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import CreateCloneEventLeaguePopup from './create_clone_event_league_popup'
import CategoryPopup from '../../../components/popups/category_popup'
import ChangeCategoryPopupSimGolf from '../../../components/sim_golf/popups/change_category_popup_sim_golf'
import ChangeSeasonPopupSimGolf from '../../../components/sim_golf/popups/change_season_popup_sim_golf'
import ChangeNamePopupSimGolf from '../../../components/sim_golf/popups/change_name_popup_sim_golf'
import ChangeTourPopup from '../../../components/popups/change_tour_popup'
import InvitationListRegistrationPopupSimGolf from '../popups/invitation_list_registration_popup_sim_golf'
import ExistingTimesPopup from '../../../components/popups/existing_times_popup'

const CCPopupsComponentSimGolf = ({
  closePopup,
  categoryPopup,
  advanceToCopyOptions,
  invitationListRegistrationPopup,
  changeCategory,
  changeSeason,
  changeName,
  changeTour,
  changeLeagueCategory,
  changeLeagueSeason,
  changeLeagueName,
  changeLeagueTour,
  updateOpenRegistrationStatus,
  userIsAdmin,
  canCreateDCP,
  getLeagueFieldDataSimGolf,
  getLeaguePotentialCloneCandidate,
  existingTimesPopup,
  advanceToInvitationList,
  updateCategoriesSimGolf,
  createCategory,
  createCloneEventLeague,
  nextButton,
}) =>
  <Fragment>
    <CreateCloneEventLeaguePopup
      onClose={ closePopup }
      canCreateDCP={ canCreateDCP }
      getLeagueFieldDataSimGolf={ getLeagueFieldDataSimGolf }
      getLeaguePotentialCloneCandidate={ getLeaguePotentialCloneCandidate }
      onSave={ advanceToCopyOptions }
      nextButton={ nextButton }
      { ...createCloneEventLeague}
    />
    <CategoryPopup
      { ...categoryPopup }
      onClose={ closePopup }
      onUpdate={ updateCategoriesSimGolf }
      onCreate={ createCategory }
      userIsAdmin={ userIsAdmin }
    />
    <ChangeCategoryPopupSimGolf
      { ...changeCategory }
      onClose={ closePopup }
      onSave={ changeLeagueCategory }
    />
    <ChangeSeasonPopupSimGolf
      { ...changeSeason }
      onClose={ closePopup }
      onSave={ changeLeagueSeason }
    />
    <ChangeNamePopupSimGolf
      { ...changeName }
      onClose={ closePopup }
      onSave={ changeLeagueName }
    />
    <ChangeTourPopup
      { ...changeTour }
      onClose={ closePopup }
      onSave={ changeLeagueTour }
    />
    <InvitationListRegistrationPopupSimGolf
      { ...invitationListRegistrationPopup }
      onClose={ closePopup }
      onSave={ updateOpenRegistrationStatus }
    />
    <ExistingTimesPopup
      { ...existingTimesPopup }
      onClose={ closePopup }
      onSave={ advanceToInvitationList }
    />
  </Fragment>


CCPopupsComponentSimGolf.propTypes = {
  closePopup: PropTypes.func.isRequired,
  categoryPopup: PropTypes.object.isRequired,
  invitationListRegistrationPopup: PropTypes.object.isRequired,
  changeCategory: PropTypes.object.isRequired,
  changeSeason: PropTypes.object.isRequired,
  changeName: PropTypes.object.isRequired,
  changeTour: PropTypes.object.isRequired,
  updateCategoriesSimGolf: PropTypes.func.isRequired,
  createCategory: PropTypes.func.isRequired,
  changeLeagueCategory: PropTypes.func.isRequired,
  changeLeagueSeason: PropTypes.func.isRequired,
  changeLeagueName: PropTypes.func.isRequired,
  changeLeagueTour: PropTypes.func.isRequired,
  updateOpenRegistrationStatus: PropTypes.func.isRequired,
  advanceToCopyOptions: PropTypes.func.isRequired,
  userIsAdmin: PropTypes.bool.isRequired,
  canCreateDCP: PropTypes.bool,
  getLeagueFieldData: PropTypes.func,
  getLeaguePotentialCloneCandidate: PropTypes.func,
  existingTimesPopup: PropTypes.object.isRequired,
  advanceToInvitationList: PropTypes.func.isRequired,
}

export default CCPopupsComponentSimGolf